import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { hasCardAccess } from '../utils/permissionHelper';

/**
 * Protected Route Component
 * Checks if user is authenticated and has required card permission
 * Redirects to login if not authenticated
 * Redirects to unauthorized if not authorized
 *
 * The left navigation is NOT added here — it comes from the <ProtectedShell>
 * layout route these routes sit under, which stays mounted while the user moves
 * between modules. Wrapping each page individually would tear the navigation
 * down and rebuild it (and re-fetch its counts) on every click.
 */
const ProtectedRoute = ({ children, requiredCard = null }) => {
    const { user, token } = useAuth();
    const location = useLocation();

    // Check if user is authenticated
    if (!token || !user) {
        return <Navigate to="/login" replace />;
    }

    // Check card-level permissions if requiredCard is specified
    // Admin bypasses card-level checks
    if (requiredCard && user.role !== 'admin') {
        // If user has no permissions object, deny access
        if (!user.permissions) {
            return <Navigate to="/unauthorized" replace />;
        }
        
        const hasAccess = hasCardAccess(user.permissions, requiredCard);
        if (!hasAccess) {
            return <Navigate to="/unauthorized" replace />;
        }
    }

    // User is authenticated and authorized
    return children;
};

export default ProtectedRoute;
